import { v4 as uuid } from 'uuid';

/**
 * Generate an id with an optional prefix
 * The uuid is shortened for easier debugging
 */
export const generateId = (
  prefix?: string,
  isDev = process.env.NODE_ENV === 'development',
) => {
  let id: string;
  if (isDev) {
    id = uuid().split('-')[0];
  } else {
    id = uuid();
  }
  return prefix ? `${prefix}-${id}` : id;
};
